import { Component, Input } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

import { IconComponent } from '@atoms/icon/icon.component';

@Component({
  selector: 'app-modal-sidebar',
  imports: [TranslateModule, IconComponent],
  templateUrl: './modal-sidebar.component.html',
  styleUrl: './modal-sidebar.component.scss',
})
export class ModalSidebarComponent {
  @Input('logo-position') logoPosition: 'top' | 'bottom' = 'top';
  @Input() socials: boolean = true;
}
